export const Poll = () => {
	const param = window.location.search;
	const pollID = param.substring(param.indexOf('?id=') + 4);

	return ( <>
		{pollID}
	</> );
}